import React from 'react';
import { Heart, Phone, Mail, Facebook, Instagram } from 'lucide-react';
import { clinicInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_heart-paws-vet/artifacts/yu8d4sa5_ChatGPT%20Image%202%20de%20nov.%20de%202025%2C%2018_55_34.png" 
                alt="Logo" 
                className="w-12 h-12 object-contain"
                style={{ filter: 'brightness(0) saturate(100%) invert(31%) sepia(89%) saturate(2715%) hue-rotate(258deg) brightness(91%) contrast(92%)' }}
              />
              <div>
                <h3 className="text-xl font-bold">{clinicInfo.name}</h3>
                <p className="text-sm text-gray-400">Cuidando com amor</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Seu pet merece o melhor cuidado veterinário. Atendimento com amor e profissionalismo.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Início
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Sobre
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Serviços
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('appointment')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Agendar
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm">
                <Phone className="w-4 h-4 text-purple-400" />
                <a href={`tel:${clinicInfo.phone}`} className="text-gray-400 hover:text-white transition-colors">
                  (11) 94932-1508
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Mail className="w-4 h-4 text-purple-400" />
                <a href={`mailto:${clinicInfo.email}`} className="text-gray-400 hover:text-white transition-colors break-all">
                  {clinicInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-bold mb-4">Redes Sociais</h4>
            <div className="flex gap-3">
              <a
                href={`https://instagram.com/${clinicInfo.instagram.replace('@', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-purple-600 hover:bg-purple-700 p-3 rounded-full transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={`https://facebook.com/${clinicInfo.facebook}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-purple-600 hover:bg-purple-700 p-3 rounded-full transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
            <p className="text-gray-400 text-sm mt-4">{clinicInfo.hours}</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} {clinicInfo.name}. Todos os direitos reservados.
            </p>
            <p className="text-gray-400 text-sm flex items-center gap-2">
              Feito com <Heart className="w-4 h-4 text-red-500 fill-red-500" /> para pets
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;